<!--歷史訂單-->
<template>
    <div class="bco-box">
        <div class="top-nav">
            <span class="text"> 快捷買幣 > </span>
            <span class="text2"> 歷史訂單 </span>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="全部订单" name="1"></el-tab-pane>
            <el-tab-pane label="已完成" name="2"></el-tab-pane>
            <el-tab-pane label="未完成" name="3"></el-tab-pane>
        </el-tabs>

        <div class="MetaTrader5-bottom-content">
            <div class="trend-head">
                <div class="column" style="width: 200px;">訂單編號</div>
                <div class="column">種類</div>
                <div class="column">總金額</div>
                <div class="column">幣種</div>
                <div class="column">數量</div>
                <div class="column">手續費</div>
                <div class="column">狀態</div>
                <div class="column" style="width: 160px;">交易時間</div>
                <div class="column">操作</div>
            </div>
            <div class="scroll-wrap">
                <ul class="trend-body">
                    <li class="row">
                        <div class="column" style="width: 200px;">訂單編號</div>
                        <div class="column">種類</div>
                        <div class="column">總金額</div>
                        <div class="column">幣種</div>
                        <div class="column">數量</div>
                        <div class="column">手續費</div>
                        <div class="column">狀態</div>
                        <div class="column" style="width: 160px;">交易時間</div>
                        <div class="column">操作</div>
                    </li>
                </ul>
            </div>

            <div class="bottom-more">没有更多了</div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            activeName: "1",
        };
    },
    mounted() {

    },
    beforeUnmount() { },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #232437 !important;
}

::v-deep .el-tabs__header {
    margin: 0px;
}

::v-deep .el-tabs__item.is-active {
    color: #fff !important;
}

::v-deep .el-tabs__item {
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #888 !important;
}

::v-deep .el-tabs__active-bar {
    background-color: #fff !important;
}

.bco-box {
    color: #fff;
    width: 90%;
    margin: 0 auto;

    .top-nav {
        font-size: 14px;
        height: 60px;

        .text {
            line-height: 60px;
            font-weight: 400;
            font-size: 14px;
            color: #556dea;
            cursor: pointer;
        }
    }
}

.MetaTrader5-bottom-content {
    padding: 0 20px 20px;
    border: 1px solid #2c2c3e;
    text-align: center;
    min-height: 250px;
    margin-top: 10px;

    .trend-head {
        height: 60px;
        line-height: 60px;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 2px;
        color: #fff;
        border-bottom: 1px solid #2c2c3e;

        .column {
            flex: 1;
        }
    }

    .scroll-wrap {
        .trend-body {
            .row {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 2px;
                font-size: 14px;
            }

            .column {
                flex: 1;
                min-height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        ol,
        ul {
            list-style: none;
        }
    }

    .bottom-more {
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
        color: #888;
    }
}
</style>